import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import UpcomingRacesRibbon from "@/components/UpcomingRacesRibbon";
import BrandStripSection from "@/components/BrandStripSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import EventsSection from "@/components/EventsSection";
import TerroirsSection from "@/components/TerroirsSection";
import CommunityRunsSection from "@/components/CommunityRunsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import CTASection from "@/components/CTASection";
import FAQSection from "@/components/FAQSection";
import ShopTeaser from "@/components/shop/ShopTeaser";
import FinalCTASection from "@/components/FinalCTASection";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useSEO";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Index = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    // Wait a tick for sections to render
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => clearTimeout(t);
  }, [hash]);

  useSEO({
    title: 'Courses à pied, Marathons & Trails en France',
    description: "Découvrez et inscrivez-vous aux courses à pied, marathons, trails et sorties running en France. Organisez vos événements sportifs avec Kourse.",
    url: 'https://kourse.fr',
    breadcrumbs: [{ name: 'Accueil', url: 'https://kourse.fr' }],
  });

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <div className="pt-24 lg:pt-28">
          <UpcomingRacesRibbon />
        </div>
        <HeroSection />
        <BrandStripSection />
        <HowItWorksSection />
        <EventsSection />
        <TerroirsSection />
        <CommunityRunsSection />
        <TestimonialsSection />
        <CTASection />
        <ShopTeaser />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
